<template>
  <v-container>
    <v-card class="ml-3 mt-2">
      <!-- Toolbar. -->
      <v-toolbar class="white--text" color="indigo" dense flat>

        <!-- Titolo. -->
        <v-toolbar-title> Controllo Qualità
          <v-icon color="white" class="mt-n1">mdi-file-check-outline</v-icon>
        </v-toolbar-title>

        <!-- Pulsante "Qualità esterno"
              (NON UTILIZZATO)
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-2" small v-bind="attrs" v-on="on">
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Qualità esterno</span>
        </v-tooltip> -->

        <!-- Pulsante "Anomalie esterno"
              (NON UTILIZZATO)
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small v-on="on" v-bind="attrs" class="ml-2" @click="check_signal_visible = true">
              <v-icon color="primary">mdi-puzzle-outline</v-icon>
            </v-btn>
          </template>
          <span>Anomalie esterno</span>
        </v-tooltip> -->

        <!-- Pulsante "Allegati esterno"
              (NON UTILIZZATO)
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small class="ml-2" v-on="on" v-bind="attrs" @click="check_allegati_visible = true">
              <v-icon color="primary">mdi-paperclip</v-icon>
            </v-btn>
          </template>
          <span>Allegati esterno</span>
        </v-tooltip> -->

        <!-- Pulsante "Articolo esterno"
              (NON UTILIZZATO)
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small class="ml-2" v-on="on" v-bind="attrs" @click="check_articolo_visible = true">
              <v-icon color="primary">mdi-dolly</v-icon>
            </v-btn>
          </template>
          <span>Articolo esterno</span>
        </v-tooltip> -->

        <v-tooltip bottom>
           <template v-slot:activator="{ on, attrs }">
            <v-btn small class="ml-2" v-on="on" v-bind="attrs" @click="check_mag_visible = true">
              <v-icon color="primary">mdi-factory</v-icon>
            </v-btn>
          </template>
          <span>Magazzino esterno</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small class="ml-2" v-on="on" v-bind="attrs" @click="check_resources_visible = true">
              <v-icon color="primary">mdi-paperclip</v-icon>
            </v-btn>
          </template>
          <span>Risorse esterno</span>
        </v-tooltip>

        <v-spacer/>
        <!-- Pulsante indietro. -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="gotoDashboard" v-bind="attrs" v-on="on" small>
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </template>
          <span>Vai alla Dashboard</span>
        </v-tooltip>
      </v-toolbar>

      <v-layout class="justify-center">
        <v-card-actions colored-border>
          <v-row>
            <!-- Pulsante benestare. -->
            <v-col cols="12">
              <v-hover>
                <template v-slot="{ hover }">
                  <v-btn medium class="primary--text" style="font-size: 25px; font-weight: 700" @click="clickBenestare"
                    :elevation="hover ? 0 : 5">
                    Benestare
                  </v-btn>
                </template>
              </v-hover>
            </v-col>

            <!-- Pulsante piano controllo. -->
            <v-col class="" cols="12">
              <v-hover>
                <template v-slot="{ hover }">
                  <v-btn medium class="elevation-5 primary--text" style="font-size: 25px; font-weight: 700"
                    @click="clickPianoControllo" :elevation="hover ? 0 : 5">
                    Piano Controllo
                  </v-btn>
                </template>
              </v-hover>
            </v-col>

            <!-- Pulsante ciclo autocontrollo. -->
            <v-col cols="12">
              <v-hover>
                <template v-slot="{ hover }">
                  <v-btn medium class="primary--text" style="font-size: 25px; font-weight: 700"
                    @click="clickAutoControllo" :elevation="hover ? 0 : 5">
                    Ciclo Autocontrollo
                  </v-btn>
                </template>
              </v-hover>
            </v-col>

          </v-row>
        </v-card-actions>
      </v-layout>

      <!-- Dialog qualità. -->
      <v-dialog class="ma-0 pa-0" width="1200px" v-model="check_quality_visible" :key="check_quality_visible" persistent>
        <v-card class="ma-0 pa-0" style="overflow: hidden" height="calc(100vh - 100px)">
          <WindowFrame class="ma-0 pa-0" referrerpolicy="origin" ref="windowframe_quality" :component="'quality'"
            :input_args="input_args" :route="route" @click_chiudi="check_quality_visible = false" />
        </v-card>
      </v-dialog>
      <!-- Dialog qualità. -->
      <v-dialog class="ma-0 pa-0" width="1200px" v-model="check_resources_visible">
        <v-card class="ma-0 pa-0" style="overflow: hidden" height="calc(100vh - 100px)">
          <WindowFrame class="ma-0 pa-0" referrerpolicy="origin" ref="windowframe_resources" :component="'resources'"
            :input_args="input_args" :route="route" @click_chiudi="check_resources_visible = false"
            @loaded="sendParamsResources" />
        </v-card>
      </v-dialog>
      <!-- Dialog magazzino. -->
      <v-dialog class="ma-0 pa-0" v-model="check_mag_visible" width="calc(100vw - 100px)">
        <v-card class="ma-0 pa-0" style="overflow: hidden" height="calc(100vh - 100px)">
          <WindowFrame class="ma-0 pa-0" referrerpolicy="origin" ref="windowframe_magazzino" :component="'magazzino'"
            :input_args="input_args" :route="route" @click_chiudi="check_mag_visible = false"
            @loaded="sendParamsMag" />
        </v-card>
      </v-dialog>

<!-- Dialog qualità. -->
      <v-dialog class="ma-0 pa-0" width="1200px" v-model="check_resources_visible">
        <v-card class="ma-0 pa-0" style="overflow: hidden" height="calc(100vh - 100px)">
            <WindowFrame
              class="ma-0 pa-0"
              referrerpolicy="origin"
              ref="windowframe_resources"
              :component="'resources'"
              :input_args="input_args"
              :route="route"
              @click_chiudi="check_resources_visible = false"
            />
        </v-card>
      </v-dialog>

      <!-- Dialog anomalie.
      <v-dialog class="ma-0 pa-0" width="1200px" v-model="check_signal_visible">
        <v-card class="ma-0 pa-0" style="overflow: hidden" height="calc(100vh - 100px)">
          <div style="position: relative; height: 100%">
            <WindowFrame
              class="ma-0 pa-0"
              referrerpolicy="origin"
              ref="windowframe_signal"
              :component="'signal'"
              :input_args="input_args_anom"
              @click_chiudi="check_signal_visible = false"
            />
          </div>
        </v-card>
      </v-dialog> -->

      <!-- Dialog allegati. 
      <v-dialog class="ma-0 pa-0" width="1200px" v-model="check_allegati_visible">
        <v-card class="ma-0 pa-0" style="overflow: hidden" width="calc(100vw - 100px)" height="calc(100vh - 100px)">
          <div style="position: relative; height: 100%">
            <WindowFrame
              class="ma-0 pa-0"
              referrerpolicy="origin"
              ref="windowframe_allegati"
              :component="'allegati'"
              :input_args="input_args_all"
              @click_chiudi="check_allegati_visible = false"
            />
          </div>
        </v-card>
      </v-dialog> -->

      <!-- Dialog articoli. 
      <v-dialog class="ma-0 pa-0" width="1400px" v-model="check_articolo_visible">
        <v-card class="ma-0 pa-0" style="overflow: hidden" height="calc(100vh - 100px)">
          <div style="position: relative; height: 100%">
            <WindowFrame
              class="ma-0 pa-0"
              referrerpolicy="origin"
              ref="windowframe_articolo"
              :component="'articolo'"
              :input_args="input_args_art"
              @click_chiudi="check_articolo_visible = false"
            />
          </div>
        </v-card>
      </v-dialog>  -->
    </v-card>
  </v-container>
</template>

<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "Menu",
  components: { WindowFrame },
  data() {
    return {
      check_mag_visible: false,
      route: null,
      check_quality_visible: false,
      check_resources_visible: false,
      //check_signal_visible: false,
      //check_allegati_visible: false,
      //check_articolo_visible: false,
      input_args: {},
      input_args_anom: {},
      // ??
      /*input_args_all: {
        id_utente: localStorage.id,
        id_riferimento: 22138,
        cod_riferimento: "commessa",
        pk_riferimento: "id_commessa",
      },*/
      input_args_art: {},
    };
  },
  computed: {},
  methods: {
    sendParamsMag() {
      this.$refs.windowframe_magazzino.postEvent("setparams", {
        param_1: "Prova",

      });
    },

    sendParamsResources() {
      this.$refs.windowframe_resources.postEvent("setparams", {
        param_1: "Prova",

      });
    },
    gotoDashboard() {
      this.$router.push("/home/production");
    },
    clickBenestare() {
      //this.$emit("benestare");
      this.route = "/home/benestare";
      this.check_quality_visible = true;
    },
    clickPianoControllo() {
      //this.$emit("piano_controllo");
      this.route = "/home/pianocontrollo/lista";
      this.check_quality_visible = true;

    },
    clickAutoControllo() {
      //this.$emit("ciclo_auto_controllo");
      this.route = "/home/ciclo/lista";
      this.check_quality_visible = true;
    },

  },
};
</script>